<template>
  <PVFileUpload
    :choose-label="$t('generic.selectFile')"
    :drop-placeholder="$t('generic.dropFileHere')"
    :pt="{
      root: {
        style: {
          height: '2.25rem',
          display: 'flex',
          ...(invalid ? { 'border-color': 'red' } : {}),
        },
      },
      header: {
        style: {
          height: '2.25rem',
          padding: 0,
          order: 2,
        },
      },
      pcChooseButton: {
        root: {
          style: {
            height: '2.25rem',
          },
        },
      },
      content: {
        style: {
          'padding-left': '0.75rem',
          'flex-grow': 1,
          'align-items': 'flex-start',
          'justify-content': 'center',
          order: 1,
        },
      },
    }"
    :show-cancel-button="false"
    :show-upload-button="false"
    @select="handleFileSelected"
  >
    <template #content="uploadedFiles">
      <span class="file-input-placeholder">{{
        uploadedFiles.files?.[0]?.name ?? $tt('generic.selectFileOrDragAndDrop')
      }}</span>
    </template>
  </PVFileUpload>
</template>

<script lang="ts" setup>
  import { FileUploadSelectEvent } from 'primevue/fileupload';
  import PVFileUpload from 'primevue/fileupload';

  defineProps<{ invalid?: boolean }>();

  const file = defineModel<File | null>('file', { default: null });

  function handleFileSelected(e: FileUploadSelectEvent): void {
    file.value = e.files[0];
  }
</script>

<style lang="scss" scoped>
  /** Using same styling as in the StyledMultiselect component */
  .file-input-placeholder {
    color: $placeholder-font-color;
    font-size: 14px;
  }
</style>
